import styled from 'styled-components';
import { Button } from '../../utils/Button/Button';
import NumericInput from '../../utils/inputs/NumericInput/NumericInput';
import { theme } from '../../../styles/constants';

export const Form = styled.form`
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 600px) {
    width: unset;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 1.4rem;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
`;

export const DeleteButton = styled(Button)`
  border: 1px solid #d92d20;
  background: #fff;
  width: unset;
  padding-inline: 2.4rem;
  color: #d92d20;
`;

export const SubmitButton = styled(Button)`
  width: 16rem;
`;

export const Row = styled.div`
  display: flex;
  gap: 1.2rem;
  margin-top: 1.2rem;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const MediaContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  margin-bottom: 2.4rem;
  overflow: auto;
  max-height: 25rem;
`;

export const MediaContentContainer = styled.div`
  min-width: 14.8rem;
  max-width: 14.8rem;
  height: 14rem;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f3f4f6;

  img,
  video {
    object-fit: cover;
  }
`;

export const LoadingContainer = styled.div`
  height: 44.7rem;
  width: 70rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FreePreviewWrapper = styled.div`
  border-radius: 4px;
  padding: 2px 6px;
  position: absolute;
  background: rgba(0, 0, 0, 0.56);
  z-index: 10;
  top: 2px;
  left: 2px;
  font-size: 1.1rem;
  font-weight: 500;
  color: #fff;
`;

export const NumberInput = styled(NumericInput)`
  width: unset;
  p {
    font-size: 1.2rem;
    font-weight: 300;
  }

  input {
    border-radius: 8px;
    border: 1px solid ${({ $error }) => ($error ? theme.colors.error : '#f3f4f6')};
    height: 3.6rem;
    width: 20rem;
    font-size: 1.4rem;
    padding: 0.4rem 0.8rem;
    padding-left: 1.6rem;
  }
`;
